/**
 * SelectInput Component
 */

import * as React from 'react';

interface IOwnProps {
  input: {
    name: string;
    value: string;
  };
  meta: {
    error?: string;
    warning?: string;
  };
  onError?: (error?: string) => void;
  onWarning?: (warning?: string) => void;
  setInitialValue?: (value: string) => void;
}

export default class SelectInput extends React.Component<IOwnProps, {}> {
  componentDidMount() {
    const {
      input: { value },
      setInitialValue,
    } = this.props;

    if (value && setInitialValue) {
      setInitialValue(value);
    }
  }
  componentWillReceiveProps({ meta: { error, warning } }: IOwnProps) {
    if (this.props.onError) {
      if (error && !this.props.meta.error) {
        this.props.onError(error);
      } else if (!error && this.props.meta.error) {
        this.props.onError();
      }
    }
    if (this.props.onWarning) {
      if (warning && !this.props.meta.warning) {
        this.props.onWarning(warning);
      } else if (!warning && this.props.meta.warning) {
        this.props.onWarning();
      }
    }
  }

  render() {
    return <input type="hidden" name={this.props.input.name} value={this.props.input.value} />;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/Select/SelectInput.tsx